import type { DataTableColumn, DataTableSortStatus } from 'mantine-datatable';

import { noop } from '@/helpers/noop';

import type { HeaderFooterDataPromise } from './hooks/exports/model';

export interface IPagination {
  totalItems: number;
  recordsPerPage?: number;
}

export enum eExportFormat {
  PDF = 'PDF',
  CSV = 'CSV',
  PRINT = 'PRINT',
  JSON = 'JSON',
  EXCEL = 'EXCEL',
  DOCX = 'Word (.docx)',
}

export type ExportableDataTableColumn<T extends object> = DataTableColumn<T> & {
  excludeFromExport?: boolean;
  isHtml?: boolean;
};

export interface IDataTableProps<T extends object> {
  data: T[];
  getExportData?: () => Promise<T[]>;
  exportTitle?: string;
  pdfHeaderFooterDataPromise?: HeaderFooterDataPromise;
  showColumnSelector?: boolean;
  showEstimationSelects?: boolean;
  hidePagination?: boolean;
  searchFunction?: (value: string) => void;
  exportConfiguration?: eExportFormat[];
  exportsAsDropdown?: boolean;
  onPageChange?: (page: number) => void;
  columnsConfiguration: ExportableDataTableColumn<T>[];
  onSortStatusChange?: (status: DataTableSortStatus<T>) => void;
  pagination: {
    totalItems: number;
    recordsPerPage: number;
  };
  fetchingData?: boolean;
  rowStyle?: (record: T) => React.CSSProperties;
  toolbarContent?: React.ReactNode;
  moreSelects?: React.ReactNode;
  className?: string;
}

export const INDEX_COLUMN_WIDTH = 50;

export const defaultDataTableProps: IDataTableProps<{ empty: '' }> = {
  columnsConfiguration: [],
  exportConfiguration: [],
  pagination: {
    totalItems: 0,
    recordsPerPage: 10,
  },
  onPageChange: noop,
  onSortStatusChange: noop,
  data: [{ empty: '' }],
  fetchingData: false,
};
